import { render, staticRenderFns } from "./CorrelationDiagram.vue?vue&type=template&id=4bf5ba48&scoped=true"
import script from "./CorrelationDiagram.vue?vue&type=script&lang=ts"
export * from "./CorrelationDiagram.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationDiagram.vue?vue&type=style&index=0&id=4bf5ba48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5ba48",
  null
  
)

export default component.exports